export { Tooltip } from "@mantine/core";
export type { TooltipProps } from "@mantine/core";
export { tooltipOverrides } from "./Tooltip.config";
